import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationService} from '../../services/navigation/navigation.service';
import {NavigableComponent} from '../../model/navigable-component';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {AnalyticsService} from '../../services/analytics/analytics.service';
import {Router} from '@angular/router';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';
import {PageNames} from '../../shared/page-names.enum';
import {ProductTypeRenditionEnum} from '../../constants/renditions/product-type-rendition.constants';
import {TvShopEntertainmentPackGroupIds} from '../../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';
import {StreamingServicesUtil} from '../../utils/streaming-services.util';

@Component({
  selector: 'app-netflix-services-details',
  templateUrl: './netflix-services-details.component.html',
  styleUrls: ['./netflix-services-details.component.less']
})
export class NetflixServicesDetailsComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {

  pack: TvShopEntertainmentPack;
  superiorSubscribedPack: TvShopEntertainmentPack;
  rendition: ProductTypeRenditionEnum = ProductTypeRenditionEnum.default;

  @ViewChild('productdetailcontent', {read: ElementRef})
  productDetailContentElement: ElementRef;

  constructor(protected navigationService: NavigationService,
              private changeDetector: ChangeDetectorRef,
              private analyticsService: AnalyticsService,
              private stateService: TvShopStateService,
              private router: Router) {
    super(navigationService);
  }

  ngOnInit() {
    this.navigationService.setCurrentPageComponent(PageNames.DETAIL_PAGE_INTRO);
    this.pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    this.setCorrectPackIdIfNecessary();
    this.setRendition();
    this.analyticsService.onDetailPage([this.pack.omapiId]);
  }

  ngOnDestroy() {
    this.navigationService.clearNavigation();
  }

  ngAfterViewInit() {
    this.navigationService.resetNavigation();
    this.changeDetector.detectChanges();
    this.navigationService.registerPageElement(this.productDetailContentElement);
  }

  goToOptionsPage(): void {
    if (!this.pack.subscribed) {
      this.stateService.setIsStreamingBundleOrder(true);
      this.router.navigate(['/product-details', this.pack.omapiId, 'option'], {queryParamsHandling: 'merge'});
    }
  }

  private setRendition() {
    if (this.pack.isStreamingBundle) {
      this.rendition = ProductTypeRenditionEnum.streamingBundle;
    } else if (this.pack.isStreamingStandaloneProduct) {
      this.rendition = ProductTypeRenditionEnum.netflixStandalone;
    } else if (this.pack.isGroupPack && this.pack.omapiId === TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE) {
      this.rendition = ProductTypeRenditionEnum.netflixStandalone;
    }
  }

  private setCorrectPackIdIfNecessary() {
    if (OmapiIdsUtils.NETFLIX_STANDALONE_PRODUCTS.some(sp => sp === this.pack.omapiId)) {
      this.pack = StreamingServicesUtil.getNetflixStandaloneGroup(this.stateService.selectSnapshot(state => state.tvShopEntertainmentPackGroups));
    }
  }
}
